/* tslint:disable */
/* eslint-disable */
/**
 * TOM PLANNING SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const OrderUpdateType = {
    Create: 'Create',
    Update: 'Update',
    Merge: 'Merge',
} as const;

export type OrderUpdateType = typeof OrderUpdateType[keyof typeof OrderUpdateType];



